'use client';

import React from 'react';
import { usePathname } from 'next/navigation';
import GalleryCard from '@/components/ui/GalleryCard';
import SectionBase from '@/components/ui/sections/section-base';
import SectionHeader from '@/components/ui/sections/section-header';
import { getServicePath } from '@/lib/utils';
import { DEFAULT_GALLERY_TAG, GALLERY_SECTION_ID } from './consts';

export default function Gallery() {
  const pathname = usePathname();
  const servicePath = getServicePath(pathname);

  if (!servicePath) {
    return null;
  }

  const galleryTag = DEFAULT_GALLERY_TAG[servicePath];

  return (
    <SectionBase id={GALLERY_SECTION_ID} background="bg-background">
      <div className="flex flex-col items-center gap-10">
        <SectionHeader
          subtitle="OUR WORK"
          title="See Our Craftsmanship in Action"
          description="Browse photos of custom homes, barns, cottages, and more built by Cornerstone Homes across Claremore, Rogers County, and the Tulsa metro area."
        />
        <div className="w-full">
          <GalleryCard tags={galleryTag} />
        </div>
      </div>
    </SectionBase>
  );
}
